import {bool, number, string, oneOf, shape, object} from 'prop-types';
import includes from 'lodash/includes';
import range from 'lodash/range';
import moment from 'moment';
import {keyMirror, formatDate, SitesByLanguage} from 'utils/DBUtils';

export const DEFAULT_LANG = 'en-US';

export const TableViewModes = Object.freeze(keyMirror({
  ReadOnly: null,
  Live: null,
  Planning: null
}));

export const RetailerItemFormModes = Object.freeze(keyMirror({
  Create: null,
  Update: null
}));

export const StoreStockFormModes = Object.freeze(keyMirror({
  Increase: null,
  Decrease: null
}));

export const UserLevels = Object.freeze({
  Coffee: 'COFFEE',
  Lunch: 'LUNCH',
  Weekend: 'WEEKEND',
  Spring: 'SPRING',
  Summer: 'SUMMER',
});

const startingYear = 2018; // the year this feature was implemented

// FIXME: this may be returned from the API eventually?
export const validYears = [
  startingYear,
  ...range((moment().year() - startingYear) + 1).map(i => moment().year(startingYear + i + 1).year())
];

export const LocalDateTimePropType = shape({
  date: shape({
    year: number.isRequired,
    month: number.isRequired,
    day: number.isRequired
  }).isRequired,
  time: shape({
    hour: number.isRequired,
    minute: number.isRequired,
    second: number.isRequired,
    nano: number.isRequired
  }).isRequired
});

export const RetailerItemPropType = shape({
  allocated: number.isRequired,
  canDelete: bool.isRequired,
  cost: number.isRequired,
  description: string.isRequired,
  id: number.isRequired,
  imageId: string,
  inStock: number.isRequired,
  lang: oneOf(Object.keys(SitesByLanguage)),
  legal: string.isRequired,
  level: string.isRequired,
  points: number.isRequired,
  price: number.isRequired,
  purchased: number.isRequired,
  resourceId: shape({
    type: oneOf(['RetailerItem', 'StoreCatalog']).isRequired,
    id: number.isRequired
  }).isRequired,
  retailerId: number.isRequired,
  title: string.isRequired
});

export const RetailerItemImageType = 'retailerItemImage';



// WEBPACK FOOTER //
// ./public/pages/Rewards/utils.js